<template>
  <v-dialog
    v-model="dialog"
    :max-width="$vuetify.breakpoint.smAndDown || forceMobile ? '100%' : '600'"
  >
    <vendor-form
      v-model="vendor"
      :isUpdating="isUpdating"
      @handle-event="dialog = !dialog"
    ></vendor-form>
  </v-dialog>
</template>
<script>
import VendorForm from "@/components/VendorForm.vue";
export default {
  name: "VendorDialog",
  components: {
    "vendor-form": VendorForm,
  },
  props: {
    forceMobile: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
    pVendor: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    vendor: {
      get() {
        return this.pVendor;
      },
      set(val) {
        this.$emit("handle-change", val);
      },
    },
  },
};
</script>
